import React, {Component} from 'react';
// style
import keyboardStyle from '../css/keyboard.css';
import {OPERATOR} from "../../../constants/operator";
import {getDecimalSeparator, getformattedNumber, getText} from "../../../helpers/localization";
import {ASSETS_URL} from "../../../constants/endpoints";
import {isBetValid} from "../helpers/betHelpers";
import {updateOpenBetStake} from "../actions/openBetsActions";
import {getGameCategoryNameByChannel} from '../helpers/gameHelpers'

let pointerEventsSupported = false;
//required for long press
let timer;
let touchDuration = 500;
const keypadGreek = 'Greek';

class Keyboard extends Component {

    componentDidMount() {
        pointerEventsSupported = window.PointerEvent;

        //this is required to chrome andorid that open context menu and remove the focus from the input
        window.oncontextmenu = function (event) {
            event.preventDefault();
            event.stopPropagation();

            document.getElementById(this.props.selectedInputElementId).focus();
            if (this.props.lastFocusedBetStake !== undefined) {
                document.getElementById(this.props.selectedInputElementId).value = this.props.lastFocusedBetStake;
            } else {
                document.getElementById(this.props.selectedInputElementId).value = '';
            }

            let gameCategory = getGameCategoryNameByChannel(this.props.store, this.props.lastFocusedBetStake.bets[0].event.channel);
            if (isBetValid(this.props.lastFocusedBetStake, this.props.store, gameCategory)) {
                this.props.store.dispatch(updateOpenBetStake(this.props.betFocused, this.props.lastFocusedBetStake));
            }

            if (this.lastKeyPressed !== undefined) {
                //only backspace has a long press
                if (this.lastKeyPressed === '{bksp}') {
                    this.props.onKeyPress(this.lastKeyPressed, true);
                }
                this._handleMouseUp(event, this.lastKeyPressed);
            }
            return false;
        }.bind(this);

        this.isButtonUp = true;
        this.isButtonDown = false;

    }

    componentWillUnmount() {
        window.oncontextmenu = undefined;
    }

    touchstart(value) {
        timer = setTimeout(() => {
            if (value === '{bksp}') {
                this.props.onKeyPress(value, true)
            }
        }, touchDuration);
    }

    touchend() {
        //stops short touches from firing the event
        if (timer) {
            clearTimeout(timer); // clearTimeout, not cleartimeout..
        }

    }

    render() {

        let deleteIcon = (<img id={'deleteIcon'} src={`${ASSETS_URL}delete.svg`}
                               className={OPERATOR.virtualKeyboardStyle == keypadGreek ? keyboardStyle.deleteIconGreek : keyboardStyle.deleteIcon}
                               alt={'delete'}/>);

        let keypad = null;
        if (OPERATOR.virtualKeyboardStyle !== keypadGreek) {

            let numberButtons = (
                <table className={keyboardStyle.numbersButtons}>
                    <tbody>
                    <tr className={keyboardStyle.row}>
                        {this._createButton(1, 1, true)}
                        {this._createButton(2, 2, true)}
                        {this._createButton(3, 3, true)}
                    </tr>
                    <tr className={keyboardStyle.row}>
                        {this._createButton(4, 4, true)}
                        {this._createButton(5, 5, true)}
                        {this._createButton(6, 6, true)}
                    </tr>
                    <tr className={keyboardStyle.row}>
                        {this._createButton(7, 7, true)}
                        {this._createButton(8, 8, true)}
                        {this._createButton(9, 9, true)}
                    </tr>
                    <tr className={keyboardStyle.row}>
                        {this._createButton(getDecimalSeparator(this.props.store), getDecimalSeparator(this.props.store), false)}
                        {this._createButton(0, 0, true)}
                        {this._createButton('{bksp}', deleteIcon, true)}
                    </tr>
                    </tbody>
                </table>);

            let incrementButtons = OPERATOR.incrementButtons.split(',').map(buttonValue => {
                let value = '+' + getformattedNumber(this.props.store, buttonValue, 0);
                return (
                    <tr key={buttonValue} className={keyboardStyle.row}>
                        {this._createButton(value, value, false)}
                    </tr>);
            })

            let quickPickButtons = (
                <React.Fragment>
                    {numberButtons}
                    <table className={keyboardStyle.quickPickButtons}>
                        <tbody>
                        {incrementButtons}
                        <tr className={keyboardStyle.row}>
                            {this._createButton('OK', getText('OK', this.props.store), false)}
                        </tr>
                        </tbody>
                    </table>
                </React.Fragment>
            );
            keypad = {...quickPickButtons};
        } else {
            const incrementButtonsStyle = `${keyboardStyle.buttonGreek}`;
            const numberButtonsStyle = `${keyboardStyle.buttonGreek}`;
            const dotStyle = `${keyboardStyle.buttonGreek} ${keyboardStyle.dotGreek}`;
            const zeroStyle = `${keyboardStyle.buttonGreek} ${keyboardStyle.zeroGreek}`;
            keypad = (
                <table className={keyboardStyle.numbersButtonsGreek}>
                    <tbody>
                    <tr className={keyboardStyle.quickPickButtonsGreek}>
                        {
                            OPERATOR.incrementButtons.split(',').map(buttonValue => {
                                let value = '+' + buttonValue;
                                return this._createButtonGreek(value, value, false, incrementButtonsStyle);
                            })
                        }
                    </tr>
                    <tr>
                        {this._createButtonGreek(1, 1, true, numberButtonsStyle)}
                        {this._createButtonGreek(2, 2, true, numberButtonsStyle)}
                        {this._createButtonGreek(3, 3, true, numberButtonsStyle)}
                        {this._createButtonGreek('{bksp}', deleteIcon, true, numberButtonsStyle)}
                    </tr>
                    <tr className={keyboardStyle.okTrGreek}>
                        {this._createButtonGreek(4, 4, true, numberButtonsStyle)}
                        {this._createButtonGreek(5, 5, true, numberButtonsStyle)}
                        {this._createButtonGreek(6, 6, true, numberButtonsStyle)}
                        {this._createButtonGreek('OK', getText('OK', this.props.store), true, numberButtonsStyle, 3, null)}
                    </tr>
                    <tr>
                        {this._createButtonGreek(7, 7, true, numberButtonsStyle)}
                        {this._createButtonGreek(8, 8, true, numberButtonsStyle)}
                        {this._createButtonGreek(9, 9, true, numberButtonsStyle)}
                    </tr>
                    <tr className={keyboardStyle.lastRowGreek}>
                        {this._createButtonGreek(0, 0, true, zeroStyle, null, 2)}
                        {this._createButtonGreek(getDecimalSeparator(this.props.store), getDecimalSeparator(this.props.store), false, dotStyle)}
                    </tr>
                    </tbody>
                </table>
            )
        }

        let useTouchEvents = this.props.store.getState().vpp.hasTouchScreen;

        if (pointerEventsSupported && !useTouchEvents) {
            return (<div
                className={OPERATOR.virtualKeyboardStyle == keypadGreek ? keyboardStyle.keyboardGreek : keyboardStyle.keyboard}
                onPointerDown={(event) => this._handleMouseDown(event)}
                onPointerUp={(event) => this._handleMouseUp(event)}> {keypad} </div>);
        } else {
            if (useTouchEvents) {
                return (<div
                    className={OPERATOR.virtualKeyboardStyle == keypadGreek ? keyboardStyle.keyboardGreek : keyboardStyle.keyboard}
                    onTouchStart={(event) => this._preventDefault(event)}
                    onTouchEnd={(event) => this._preventDefault(event)}
                    onClick={(event) => this._preventDefault(event)}> {keypad} </div>);
            } else {
                return (<div
                    className={OPERATOR.virtualKeyboardStyle == keypadGreek ? keyboardStyle.keyboardGreek : keyboardStyle.keyboard}
                    onMouseDown={(event) => this._handleMouseDown(event)}
                    onMouseUp={(event) => this._handleMouseUp(event)}> {keypad} </div>);
            }
        }

    }

    _createButtonGreek(fun, label, hasLongTouch, buttonStyle, rowSpan, colSpan) {

        let useTouchEvents = this.props.store.getState().vpp.hasTouchScreen;

        if (pointerEventsSupported && !useTouchEvents) {
            return (
                <td key={fun} className={buttonStyle}
                    rowSpan={rowSpan ? rowSpan : null}
                    colSpan={colSpan ? colSpan : null}
                    onPointerDown={(event) => this._handleMouseDown(event, fun, hasLongTouch)}
                    onPointerUp={event => this._handleMouseUp(event, fun)}
                >{label}</td>);
        } else {
            if (useTouchEvents) {
                return (
                    <td key={fun} className={buttonStyle}
                        rowSpan={rowSpan ? rowSpan : null}
                        colSpan={colSpan ? colSpan : null}
                        onTouchStart={(event) => this._handleMouseDown(event, fun, hasLongTouch)}
                        onTouchEnd={event => this._handleMouseUp(event, fun)}
                        onTouchMove={(event) => this._preventDefault(event)}
                        onClick={(event) => this._preventDefault(event)}>{label}</td>);
            } else {
                return (
                    <td key={fun} className={buttonStyle}
                        rowSpan={rowSpan ? rowSpan : null}
                        colSpan={colSpan ? colSpan : null}
                        onMouseDown={(event) => this._handleMouseDown(event, fun, hasLongTouch)}
                        onMouseUp={event => this._handleMouseUp(event, fun)}>{label}</td>);
            }
        }

    }

    _createButton(fun, label, hasLongTouch) {

        let useTouchEvents = this.props.store.getState().vpp.hasTouchScreen;

        if (pointerEventsSupported && !useTouchEvents) {
            return (
                <td className={keyboardStyle.button}
                    onPointerDown={(event) => this._handleMouseDown(event, fun, hasLongTouch)}
                    onPointerUp={event => this._handleMouseUp(event, fun)}
                >{label}</td>);
        } else {
            if (useTouchEvents) {
                return (
                    <td className={keyboardStyle.button}
                        onTouchStart={(event) => this._handleMouseDown(event, fun, hasLongTouch)}
                        onTouchEnd={event => this._handleMouseUp(event, fun)}
                        onTouchMove={(event) => this._preventDefault(event)}
                        onClick={(event) => this._preventDefault(event)}>{label}</td>);
            } else {
                return (
                    <td className={keyboardStyle.button}
                        onMouseDown={(event) => this._handleMouseDown(event, fun, hasLongTouch)}
                        onMouseUp={event => this._handleMouseUp(event, fun)}>{label}</td>);
            }
        }

    }

    _handleMouseDown(event, value, hasLongTouch) {
        this.lastKeyPressed = value;

        if (value !== undefined && value !== 'OK' && this.isButtonUp === true && this.isButtonDown === false) {
            this.isButtonDown = true;
            event.target.classList.add(keyboardStyle.pressed);
            this.props.onKeyPress(value);
            if (hasLongTouch) {
                this.touchstart(value);
            }
            this.isButtonUp = false;
        }
        this._preventDefault(event);
        this.isButtonDown = false;
    }

    _handleMouseUp(event, value) {
        this.lastKeyPressed = undefined;
        event.target.classList.remove(keyboardStyle.pressed);
        this.isButtonUp = true;
        this.touchend();
        if (value === 'OK') {
            this.props.onKeyPress(value);
        }
        this._preventDefault(event);
    }

    _preventDefault(event) {
        event.preventDefault();
        event.stopPropagation();
    }

}

export default Keyboard;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/keyboard.js